"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasIndependentTestingMechanism = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.HasIndependentTestingMechanism = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.has_independent_testing_mechanism.label',
    fallbackLabel: 'Do you have an independent testing mechanism in place that conducts assessments of the effectiveness of AML & CTF and sanctions programs or processes, separate from internal audit or compliance functions?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
